import fetchHandler from './Handler';

// export const createBlog = async (body) => {
//     console.log(body,"------------->")
//     try {
//         const response = await fetchHandlerForm({
//             method: 'POST',
//             endpoint: 'blog/',
//             body
//         });
//         if (response?.data) {
//             return response;
//         }
//     } catch (error) {
//         console.error('Error creating blog:', error);
//         throw error;
//     }
// };

export const cardApi = async () => {
	try {
		const response = await fetchHandler({
			method: 'GET',
			endpoint: 'card/', // Replace with your actual API endpoint
		});
		return response;
	} catch (error) {
		console.error('Error fetching blogs:', error);
		throw new Error('Could not fetch blogs. Please try again later.');
	}
};
export const chartAPi = async () => {
	try {
		const response = await fetchHandler({
			method: 'GET',
			endpoint: 'chart/', // Replace with your actual API endpoint
		});
		return response;
	} catch (error) {
		console.error('Error fetching blogs:', error);
		throw new Error('Could not fetch blogs. Please try again later.');
	}
};
export const bestSellingProductAPi = async () => {
	try {
		const response = await fetchHandler({
			method: 'GET',
			endpoint: 'bestselling/', // Replace with your actual API endpoint
		});
		return response;
	} catch (error) {
		console.error('Error fetching blogs:', error);
		throw new Error('Could not fetch blogs. Please try again later.');
	}
};
export const Dashboardapi = async (endpoint: any) => {
	try {
		const response = await fetchHandler({
			method: 'GET',
			endpoint: endpoint, // Replace with your actual API endpoint
		});
		return response;
	} catch (error) {
		console.error('Error fetching blogs:', error);
		throw new Error('Could not fetch blogs. Please try again later.');
	}
};

// export const deleteBlog = async (data) => {
// 	try {
// 		const response = await fetchHandler({
// 			method: 'DELETE',
// 			endpoint: `blog/${data}`,
// 		});
// 		return response;
// 	} catch (error) {
// 		console.error('Error deleting blog:', error);
// 		throw new Error('Could not delete blog. Please try again later.');
// 	}
// };

// export const updateBlog = async (body, id) => {
// 	try {
// 		const response = await fetchHandlerForm({
// 			method: 'PUT',
// 			endpoint: `blog/${id}`,
// 			body,
// 		});
// 		return response;
// 	} catch (error) {
// 		console.error('Error updating blog:', error);
// 		throw new Error('Could not update blog. Please try again later.');
// 	}
// };

// export const updateBlogContent = async (body, id) => {
// 	try {
// 		const response = await fetchHandlerForm({
// 			method: 'PUT',
// 			endpoint: `blog/${id}/content-section`,
// 			body,
// 		});
// 		return response;
// 	} catch (error) {
// 		console.error('Error updating blog content:', error);
// 		throw new Error('Could not update blog content. Please try again later.');
// 	}
// };

// export const updateBlogStatus = async (data, id) => {
// 	try {
// 		const response = await fetchHandler({
// 			method: 'PUT',
// 			endpoint: `blog/${id}/status`,
// 			data: data,
// 		});
// 		return response;
// 	} catch (error) {
// 		console.error('Error updating blog status:', error);
// 		throw new Error('Could not update blog status. Please try again later.');
// 	}
// };

// export const getSingleBlog = async (blogUrl) => {
// 	try {
// 		const response = await fetchHandler({
// 			method: 'GET',
// 			endpoint: `blog/${blogUrl}`,
// 		});
// 		return response;
// 	} catch (error) {
// 		console.error('Error fetching blog:', error);
// 		throw new Error('Could not fetch blog. Please try again later.');
// 	}
// };

// export const deleteBlogContentSection = async (data, id) => {
// 	try {
// 		const response = await fetchHandler({
// 			method: 'DELETE',
// 			endpoint: `blog/delete-content/${data}/${id}`,
// 		});
// 		return response;
// 	} catch (error) {
// 		console.error('Error deleting blog content section:', error);
// 		throw new Error('Could not delete blog content section. Please try again later.');
// 	}
// };
